import {
  CSV_MIME_TYPE,
  DOCX_MIME_TYPES,
  FileType,
  IMAGE_MIME_TYPES,
  JPG_MIME_TYPE,
  JSON_MIME_TYPE,
  KML_MIME_TYPE,
  PDF_MIME_TYPE,
  PNG_MIME_TYPE,
  PPTX_MIME_TYPES,
  PYTHON_MIME_TYPES,
  SHP_MIME_TYPE,
  TXT_MIME_TYPE,
  XLSX_MIME_TYPES,
  ZIP_MIME_TYPE,
} from "./types";

export const getFileType = (mimeType = "", name = ""): FileType => {
  if (mimeType === PNG_MIME_TYPE) {
    return FileType.PNG;
  }

  if (mimeType === JPG_MIME_TYPE) {
    return FileType.JPG;
  }

  if (IMAGE_MIME_TYPES.includes(mimeType)) {
    return FileType.IMAGE;
  }

  if (XLSX_MIME_TYPES.includes(mimeType)) {
    return FileType.XLSX;
  }

  if (DOCX_MIME_TYPES.includes(mimeType)) {
    return FileType.DOCX;
  }

  if (mimeType === CSV_MIME_TYPE) {
    return FileType.CSV;
  }

  if (mimeType === PDF_MIME_TYPE) {
    return FileType.PDF;
  }

  if (mimeType === JSON_MIME_TYPE) {
    return FileType.JSON;
  }

  if (mimeType === KML_MIME_TYPE && (name.endsWith(".kml") || name.endsWith(".kmz"))) {
    return FileType.KML;
  }

  if (PYTHON_MIME_TYPES.includes(mimeType)) {
    return FileType.PYTHON;
  }

  if (mimeType === TXT_MIME_TYPE && name.endsWith(".py")) {
    return FileType.PYTHON;
  }

  if (mimeType === TXT_MIME_TYPE) {
    return FileType.TXT;
  }

  if (PPTX_MIME_TYPES.includes(mimeType)) {
    return FileType.PPTX;
  }

  if (mimeType === SHP_MIME_TYPE && name.endsWith(".shp")) {
    return FileType.SHP;
  }

  if (mimeType === ZIP_MIME_TYPE) {
    return FileType.ZIP;
  }

  return name.endsWith(".py") ? FileType.PYTHON : FileType.UNKNOWN;
};
